import { CUSTOM, WEEKDAYS, WEEKENDS } from 'constants/restrictions'

export const getDayAndTimeByType = type => {
  if (type === 'C') return CUSTOM
  if (type === 'B') return WEEKDAYS
  if (type === 'W') return WEEKENDS

  return null
}
